import { advanceModalMapper } from ".";
import { Suspense } from "react";
import { Box, Modal } from "@mui/material";
import CircleLoader from "components/atoms/CircleLoader";
import ErrorBoundary from "components/atoms/ErrorBoundary";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { advanceModalActions } from "redux/slices/advanceModal";

function AdvanceModal() {
  const dispatch = useAppDispatch();
  const type = useAppSelector((state) => state.advanceModal.type);
  const open = useAppSelector((state) => state.advanceModal.open);
  const width = useAppSelector((state) => state.advanceModal.width);
  const loading = useAppSelector((state) => state.advanceModal.loading);

  return (
    <Modal
      open={open}
      onClose={() => {
        dispatch(advanceModalActions.closeAdvanceModal());
      }}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        className="app-modal-body"
        sx={{
          p: { xs: "0px", sm: "0px", md: "3px" },
          width: { xs: "90%", sm: "85%", md: width },
          border: "none",
          maxWidth: { xs: "none", md: width },
          maxHeight: { xs: "80vh", sm: "70vh", md: "81vh" },
          height: { xs: "auto", md: "auto" },
          borderRadius: "12px",
          bgcolor: "background.paper",
          ":focus-visible": {
            outline: "none",
          },
          overflowY: "auto",
        }}
      >
        <ErrorBoundary>
          <div style={{ 
            // minHeight: { xs: "100px", sm: "123px" }, 
            position: "relative" 
          }}>
            {loading && <CircleLoader />}
            <Suspense fallback={<CircleLoader />}>
              {type && advanceModalMapper[type]}
            </Suspense>
          </div>
        </ErrorBoundary>
      </Box>
    </Modal>
  );
}

export default AdvanceModal;